import { Component, OnDestroy } from '@angular/core';
import { MessageService } from '../shared/message.service';
import { Subscription } from 'rxjs';
import { Alert, AlertType } from '../shared/alert.model';

@Component({
    template: `
    <re-alert *ngIf="message" type="danger" [dismissible]="false"><strong>{{ message }}</strong></re-alert>
  `,
    standalone: false
})
export class UnauthorizedComponent implements OnDestroy {
  message: string;
  subscription: Subscription;

  constructor(private messageService: MessageService) {
    this.message = 'You\'re not authorized to access this resource.';
    this.subscription = this.messageService.get().subscribe(
      message => {
        if (message && message instanceof Alert && message.type === AlertType.DANGER) {
          this.message = message.message;
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
